/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'timeline-update': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" _fill="none" fill-rule="evenodd"><path pid="0" d="M19.5 16.5l3.91 3.91a5.5 5.5 0 017.233 7.04L28.501 25H25v3l2.59 2.59a5.5 5.5 0 01-7.179-7.179L16.5 19.5M12.5 15.5l-3.91-3.91a5.5 5.5 0 01-7.233-7.04L3.499 7H7V4L4.41 1.41A5.5 5.5 0 0111.59 8.59L15.5 12.5M29 1l2 2-3 4-3-3zM25 7L12 20M13 23l-7.414 7.414A2 2 0 014.172 31H3a2 2 0 01-2-2v-1.172a2 2 0 01.586-1.414L9 19M8.5 17.5l6 6"/></g>'
  }
})
